import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Piece} from './piece.model';

@Injectable()
export class PieceService {

    private resourceUrl = 'api/pieces';
    private publicResourceUrl = 'api/public/pieces';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    update(piece: Piece[]): Observable<Piece[]> {
        let copy: Piece[] = piece.slice(0);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Piece> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    findByCode(code: string): Observable<Piece> {
        return this.http.get(`${this.publicResourceUrl}/code/${code}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.categorieFormationIdList) {
            params.set('categorieFormationIdList', req.categorieFormationIdList);
        }
        if (req.formationId) {
            params.set('formationId', req.formationId);
        }
        if (req.isFormationContinue) {
            params.set('isFormationContinue', req.isFormationContinue);
        }
        if (req.etudiantId) {
            params.set('etudiantId', req.etudiantId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/piece.service.ts